<dx-popup
  [visible]="option.visible"
  height="fit-content"
  width="350"
  [showTitle]="false"
  [hideOnOutsideClick]="false"
>
  <div *dxTemplate="let data of 'content'">
    <div class="confirmation-body">
        <div class="confirmation-msg">
            {{option.message}}
        </div>
        <div class="confirmation-btn-block">
            <!-- <dx-button class="confirmation-btn" *ngIf="option.rejectButtonText!=''" (click)="onClick(false)" type="danger" [text]="option.rejectButtonText"></dx-button>
            <dx-button class="confirmation-btn" *ngIf="option.confirmButtonText!=''" (click)="onClick(true)" type="success" [text]="option.confirmButtonText"></dx-button>
            <dx-button class="confirmation-btn" *ngIf="option.normalButtonText!=''" (click)="onClick(true)" type="default" [text]="option.normalButtonText"></dx-button> -->
       
            <dx-button *ngIf="option.confirmButtonText!=''" class="confirmation-btn" (click)="onClick(true)" type="default" [text]="option.confirmButtonText"></dx-button>
            <dx-button *ngIf="option.rejectButtonText!=''" class="confirmation-btn" (click)="onClick(false)" type="default" [text]="option.rejectButtonText"></dx-button>
        </div>
    </div>
    
  </div>
</dx-popup>